import React from 'react';
import {
  Switch,
  HStack,
  Badge,
} from '@chakra-ui/react';
import { useRouter } from 'next/router';
import { IRole } from '../../lib/graphql';
import { useAuth } from '../../pages/api/userAuth';
import { usePreview } from '../../lib/contexts/PreviewContext';

const PreviewToggle = () => {
  const { user } = useAuth();
  const { isPreviewMode, togglePreview } = usePreview();
  const router = useRouter();

  // Only show for admin users
  if (!user?.roles.includes(IRole.Admin)) {
    return null;
  }

  const handleTogglePreview = () => {
    togglePreview();
    // Reload the current page to reflect the new preview state
    router.reload();
  };

  const badgeColorScheme = isPreviewMode ? 'orange' : 'green';
  const badgeText = isPreviewMode ? 'PREVIEW' : 'LIVE';

  return (
    <HStack spacing={3} align="center">
      <Badge
        colorScheme={badgeColorScheme}
        variant="solid"
        px={2}
        py={1}
        borderRadius="md"
        fontSize="xs"
      >
        {badgeText}
      </Badge>
      <Switch
        isChecked={isPreviewMode}
        onChange={handleTogglePreview}
        colorScheme="orange"
        size="md"
      />
    </HStack>
  );
};

export default PreviewToggle;
